import {
 ref, onMounted, onUnmounted,
} from 'vue';
import { BreakpointsEnum } from '@/js/enums/breakpoints';

const LAPTOP_WIDTH_PX = 1024;
const MENU_BREAKPOINT = 1240;

export function useCustomDeviceSize() {
    const isSidebarMobile = ref(false);
    const isCustomLaptop = ref(false);
    const isCustomDesktop = ref(false);
    const isMenuDesktop = ref(false);

    const sidebarMobileMediaQuery = `(max-width: ${BreakpointsEnum.TABLET_WIDTH_IN_PX - 1}px)`;
    const customLaptopMediaQuery = `(min-width: ${BreakpointsEnum.TABLET_WIDTH_IN_PX}px) and (max-width: ${LAPTOP_WIDTH_PX - 1}px)`;
    const customDesktopMediaQuery = `(min-width: ${LAPTOP_WIDTH_PX}px)`;
    const menuDesktopMediaQuery = `(min-width: ${MENU_BREAKPOINT}px)`;

    let sidebarMobileMatcher: MediaQueryList | undefined;
    let customLaptopMatcher: MediaQueryList | undefined;
    let customDesktopMatcher: MediaQueryList | undefined;
    let menuDesktopMatcher: MediaQueryList | undefined;

    const updateIsSidebarMobile = (event: MediaQueryListEvent | MediaQueryList) => {
        isSidebarMobile.value = event.matches;
    };

    const updateIsCustomLaptop = (event: MediaQueryListEvent | MediaQueryList) => {
        isCustomLaptop.value = event.matches;
    };

    const updateIsCustomDesktop = (event: MediaQueryListEvent | MediaQueryList) => {
        isCustomDesktop.value = event.matches;
    };

    const updateIsMenuDesktop = (event: MediaQueryListEvent | MediaQueryList) => {
        isMenuDesktop.value = event.matches;
    };

    const setInitialValues = () => {
        sidebarMobileMatcher = window.matchMedia(sidebarMobileMediaQuery);
        updateIsSidebarMobile(sidebarMobileMatcher);

        customLaptopMatcher = window.matchMedia(customLaptopMediaQuery);
        updateIsCustomLaptop(customLaptopMatcher);

        customDesktopMatcher = window.matchMedia(customDesktopMediaQuery);
        updateIsCustomDesktop(customDesktopMatcher);

        menuDesktopMatcher = window.matchMedia(menuDesktopMediaQuery);
        updateIsMenuDesktop(menuDesktopMatcher);
    };

    onMounted(() => {
        if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
            if (!customLaptopMatcher) {
                setInitialValues();
            }

            if (typeof sidebarMobileMatcher?.addEventListener !== 'function') {
                return;
            }

            sidebarMobileMatcher?.addEventListener('change', updateIsSidebarMobile);
            customLaptopMatcher?.addEventListener('change', updateIsCustomLaptop);
            customDesktopMatcher?.addEventListener('change', updateIsCustomDesktop);
            menuDesktopMatcher?.addEventListener('change', updateIsMenuDesktop);
        }
    });

    onUnmounted(() => {
        if (typeof sidebarMobileMatcher?.removeEventListener !== 'function') {
            return;
        }

        sidebarMobileMatcher?.removeEventListener('change', updateIsSidebarMobile);
        customLaptopMatcher?.removeEventListener('change', updateIsCustomLaptop);
        customDesktopMatcher?.removeEventListener('change', updateIsCustomDesktop);
        menuDesktopMatcher?.removeEventListener('change', updateIsMenuDesktop);
    });

    return {
        isSidebarMobile,
        isCustomLaptop,
        isCustomDesktop,
        isMenuDesktop,
    };
}
